import React from 'react';
import { abbreviateNum } from 'lib/helpers';

export interface Slide1Props {
  username: string;
  overallStats: any;
}

/** Slide 1 - Overall account totals */
export const Slide01 = ({
  username, overallStats,
}: Slide1Props) => (
  <div className="text-white justify-center absolute inset-0 h-full">
    <div className="absolute top-[48%] w-full">
      <div className="text-center animate-flydown opacity-0 [animation-delay:2200ms] [animation-fill-mode:both]">
        <span className="w-full">
          @
          {username}
        </span>
      </div>
      <div className="flex gap-4 items-center px-10 text-5xl pb-8 pt-4 animate-flyleft [animation-delay:2000ms] opacity-0 [animation-fill-mode:both]">
        <div className="text-4xl text-left font-light">
          posts:
        </div>
        <div className="font-bold text-right w-full">
          {abbreviateNum(overallStats.posts, 1)}
        </div>
      </div>
      <div className="flex gap-4 items-center px-9 text-5xl pb-8 animate-flyright [animation-delay:2000ms] opacity-0 [animation-fill-mode:both]">
        <div className="text-4xl text-left font-light">
          likes:
        </div>
        <div className="font-bold w-full text-right">
          {abbreviateNum(overallStats.likes, 1)}
        </div>
      </div>
      {overallStats.combinedViews > 0 && (
        <div className="flex gap-4 items-center px-9 text-5xl animate-flyleft [animation-delay:2000ms] opacity-0 [animation-fill-mode:both]">
          <div className="text-4xl text-left font-light">
            views:
          </div>
          <div className="font-bold w-full text-right">
            {abbreviateNum(overallStats.combinedViews, 1)}
          </div>
        </div>
      )}
    </div>
  </div>
);
